import { render, staticRenderFns } from "./FieldAltNextExercise.vue?vue&type=template&id=8172ab22&scoped=true&"
import script from "./FieldAltNextExercise.vue?vue&type=script&lang=ts&"
export * from "./FieldAltNextExercise.vue?vue&type=script&lang=ts&"
import style0 from "./FieldAltNextExercise.vue?vue&type=style&index=0&id=8172ab22&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8172ab22",
  null
  
)

export default component.exports